module.exports = __webpack_public_path__ + "assets/img/swiper-3.6baa10a2.jpg";